import api, { adminApiPrefix } from './Api';
import { UserFilter, userFilterToParams } from '../interfaces/User/UserFilter';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import {
  UserSummary,
  userSummaryFromResponse,
} from '../interfaces/User/UserSummary';
import {
  UserDetails,
  userDetailsFromResponse,
  userToUpdateRequest,
} from '../interfaces/User/UserDetails';
import { NewUser, newUserToInsertRequest } from '../interfaces/User/NewUser';

const usersAdminApiPrefix = `${adminApiPrefix}/users`;

export const createUser = async (newUser: NewUser): Promise<UserSummary> => {
  const response = await api.post(
    usersAdminApiPrefix,
    newUserToInsertRequest(newUser),
  );

  return userSummaryFromResponse(response.data?.data);
};

export const getUsers = async (
  filter: UserFilter,
): Promise<PaginatedResponse<UserSummary>> => {
  const response = await api.get(usersAdminApiPrefix, {
    params: userFilterToParams(filter),
  });

  return {
    data: (response.data?.data ?? []).map((user: any) =>
      userSummaryFromResponse(user),
    ),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const getUser = async (id: number): Promise<UserDetails> => {
  const response = await api.get(`${usersAdminApiPrefix}/${id}`);

  return userDetailsFromResponse(response.data?.data);
};

export const updateUser = async (user: UserDetails): Promise<void> =>
  api.put(`${usersAdminApiPrefix}/${user.id}`, userToUpdateRequest(user));

export const updateUserPassword = async (
  email: string,
  password: string,
): Promise<void> =>
  api.put(`${usersAdminApiPrefix}/password/${email}`, {
    new_password: password,
  });

export const updateAffiliateProgramForUser = async (
  id: number,
  affiliateCode?: string,
): Promise<void> =>
  api.put(`${usersAdminApiPrefix}/affiliate/${id}`, {
    affiliate_code: affiliateCode,
  });
